import { render } from "./delivery-challan-return.vue?vue&type=template&id=2c090d44&scoped=true"
import script from "./delivery-challan-return.vue?vue&type=script&lang=js"
export * from "./delivery-challan-return.vue?vue&type=script&lang=js"

import "./delivery-challan-return.vue?vue&type=style&index=0&id=2c090d44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c090d44"]])

export default __exports__